export class RefsStore {
  store(name, value) {
    this[name] = value;
  }
}



// WEBPACK FOOTER //
// ./src/utils/refsUtils.js